const styles = `
  .social-embed {
    max-width: 480px;
    /*
     * A width of less than 312px potentially breaks the layout, i.e.,
     * due to the usage of an image element scaling down the embed
     * has it's limits...
     */
    min-width: 312px;
    position: relative;
    margin-bottom: 20px;
    text-rendering: geometricPrecision;
  }

  .social-embed--feed.social-embed--feed {
    max-width: 100%;
    width: 100%;
  }

  .social-embed--rendered {
    color: #fff;
    border: 1px solid rgba(0, 47, 108, 0.1);
  }

  .social-embed__icon {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 2;
  }

  .social-embed__icon svg {
    margin-inline-start: 4px;
  }

  .social-embed__content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .social-embed__content p {
    margin-block-start: 0;
    margin-block-end: 8px;
  }

  .social-embed--tagboard .social-embed__content {
    position: relative;
    top: 0;
    left: 0;
    transform: none;
    z-index: 2;
    padding-block-start: 68px;

    /* = (Figma margins) - (default paragraph margin-block-end (8px, s.a.)) */
    padding-block-end: 60px;
  }

  .social-embed__placeholder--tagboard {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .social-embed__hidden {
    display: none;
  }

  .social-embed__call-to-action {
    font-family: "FC Sans", fcbayern_sans_semi_bold, "Helvetica Neue", Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 110%;

    border-radius: 3px;
    margin-block-end: 16px;
    background: #FFFFFF;
    border: none;
    padding: 11px 14px;
    align-items: center;
    cursor: pointer;

  }

  .social-embed__privacy.social-embed__privacy {
    font-family: "FC Sans", fcbayern_sans_regular, "Helvetica Neue", Arial, sans-serif;;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 110%;

    padding-inline-start: 35px;
    padding-inline-end: 35px;
    text-align: center;
    color: white;
  }

  .social-embed__privacy.social-embed__privacy a,
  .social-embed__privacy.social-embed__privacy a:link,
  .social-embed__privacy.social-embed__privacy a:visited,
  .social-embed__privacy.social-embed__privacy a:hover {
    font: inherit;
    color: inherit;
    text-decoration: underline;
  }

  @media screen and (min-width: 576px) {
    .social-embed__privacy.social-embed__privacy {
      padding-left: 75px;
      padding-right: 75px;
    }
  }

  .svg-preview {
    padding-bottom: 118.54166667%;
    position: relative;
  }

  .svg-preview__content {
    position: absolute;
    left:0;
    top:0;
    right: 0;
    bottom: 0;
  }
`;

document.head.appendChild(
    document.createElement('style')
).textContent = styles;
